"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toChecksumAddress = exports.isAddress = void 0;
var _web = _interopRequireDefault(require("web3"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// import store from '@/store';
//
// import {
//   isValidChecksumAddress as isValidRSKChecksumAddress,
//   toChecksumAddress as toRSKChecksumAddress
// } from 'rskjs-util';
// import { RSK, RSKTEST } from '@/networks/types';

const isAddress = address => {
  if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) {
    return false;
  } else if (/^(0x|0X)?[0-9a-f]{40}$/.test(address) || /^(0x|0X)?[0-9A-F]{40}$/.test(address)) {
    return true;
  }
  // const chainID = store.state.network ? store.state.network.type.chainID : 1;
  // if (chainID === RSK.chainID || chainID === RSKTEST.chainID)
  //   return isValidRSKChecksumAddress(address, chainID);
  return _web.default.utils.checkAddressChecksum(address);
};
exports.isAddress = isAddress;
const toChecksumAddress = address => {
  // const chainID = store.state.network ? store.state.network.type.chainID : 1;
  // if (chainID === RSK.chainID || chainID === RSKTEST.chainID)
  //   return toRSKChecksumAddress(address, chainID);
  return _web.default.utils.toChecksumAddress(address);
};
exports.toChecksumAddress = toChecksumAddress;